/* global busCalendarVars */

// Get required category ids and colors from the shortcode.
const categories = document.getElementById('calendar').dataset.categories;
const colors     = document.getElementById('calendar').dataset.colors;

initCalendar();
initCategoryKey();

/**
 * Initialize the calendar.
 */
function initCalendar() {
	document.addEventListener('DOMContentLoaded', function() {
		// Gat calender element.
		const calendarEl = document.getElementById('calendar');

		// Prepare header buttons.
		let header = {left: 'title', center: ''};
		header.right = (window.innerWidth < 768) ? 'prev,next' : 'prev,next listMonth,dayGridMonth';

		// Prepare calendar.
		const calendar = new FullCalendar.Calendar(calendarEl, {
			plugins: [ 'list', 'dayGrid' ],
			defaultView: (window.innerWidth < 768) ? 'listMonth' : 'dayGridMonth',
			events: {
				url: busCalendarVars.url + '/wp-json/bus-events/v2/events',
				extraParams: {
					categories,
					colors,
				},
			},
			eventClick: function(info) {
				info.jsEvent.preventDefault(); // don't let the browser navigate

				if (info.event.url) {
					window.open(info.event.url, '_blank');
				}
			},
			eventBackgroundColor: '#006293',
			eventBorderColor: '#006293',
			eventTextColor: '#ffffff',
			header,
			slotLabelFormat: {
				hour: 'numeric',
				minute: 'numeric',
				omitZeroMinute: false,
			},
			eventTimeFormat: {
				hour: '2-digit',
				minute: '2-digit',
			},
			timeZone: 'UTC',
			locale: 'da',
			titleFormat: function(args){
				return busCalendarCustomi18n.months[args.date.month] + ' ' + args.date.year;
			},
			columnHeaderText: function(date){
				return busCalendarCustomi18n.weeks.short[date.getDay()];
			},
			listDayFormat: function ( args ){
				return `${args.date.day} ${busCalendarCustomi18n.months[args.date.month]} ${args.date.year}`;
			},
			listDayAltFormat: function ( args ){
				return busCalendarCustomi18n.weeks.long[args.date.marker.getDay()];
			}
		});

		calendar.render();
	});
}

function initCategoryKey() {
	get(busCalendarVars.url + '/wp-json/bus-events/v2/event-categories?categories=' + categories + '&colors=' + encodeURIComponent(colors))
		.then((data) => {
			const cats  = JSON.parse(data);
			const keyEl = document.getElementById('calendar-key');

			for (let i = 0; i < cats.length; i++) {
				let newElement = keyEl.appendChild(document.createElement('div'));
				newElement.innerHTML = cats[i].name;
				newElement.classList.add('calendar-key__item');
				newElement.style.borderLeftColor = cats[i].color;
			}
		})
		.catch((err) => {
			console.log(err);
		});
}

function get(url) {
	return new Promise((resolve, reject) => {
		const req = new XMLHttpRequest();
		req.open('GET', url);
		req.onload = () => req.status === 200 ? resolve(req.response) : reject(Error(req.statusText));
		req.onerror = (e) => reject(Error(`Network Error: ${e}`));
		req.send();
	});
}
